import i18n from '@/i18n';

const $t = (text) => {
  return i18n.global.t(text);
};

export function useAdditionalInfo() {
  const getUserName = (item) => {
    const userInfo = item.addrbookAdditionalInfo.userAdditionalInfo;
    if (!userInfo || !userInfo.length) return $t('message.noUsers');
    return userInfo[0].userName || userInfo[0].user_name;
  };

  return {
    getUserName
  };
}
